import { useQuery } from '@apollo/client';

import GET_FEATURE_FLAG from '../graphql/LXGetFlagOrganization.v4.b2b.graphql';
import type {
  LXGetFlagOrganization,
  LXGetFlagOrganizationVariables,
} from '../graphql/types/LXGetFlagOrganization';

function useIsNewSidebarEnabled(organizationSlug?: string) {
  const { data, loading, called, error } = useQuery<
    LXGetFlagOrganization,
    LXGetFlagOrganizationVariables
  >(GET_FEATURE_FLAG, {
    variables: { slug: organizationSlug },
    skip: !organizationSlug,
    context: {
      clientName: 'v4.b2b',
    },
  });

  const isCrossNavigationSidebarActive =
    data?.b2bOrganizationCurrent?.features?.find(
      feature => feature?.slug === 'talent-suite',
    );

  return {
    isCrossNavigationSidebarActive: !!isCrossNavigationSidebarActive,
    loading,
    called,
    error,
  };
}

export default useIsNewSidebarEnabled;
